<script>
export default {
  methods: {
    beforeEnter () {
      this.$refs.nav.classList.add('is-hidden-mobile')
    },
    afterEnter () {
      this.$refs.nav.classList.remove('is-hidden-mobile')
    }
  }
}
</script>

<template>
  <div class="gp-staff">
    <div class="page-background"></div>

    <header>
      <h1 class="page-title">STAFF/CAST</h1>
    </header>

    <div class="tab level-center is-mobile">
      <router-link :to="{ name: 'staff' }">
        <h2
          class="gp level-center is-mobile"
          :class="{ current: !$route.meta.version }"
        >
          <img src="/assets/images/logo-gp-kana.svg" />
        </h2>
      </router-link>

      <router-link :to="{ name: 'raz-staff' }">
        <h2
          class="raz level-center is-mobile"
          :class="{ current: $route.meta.version === 'raz' }"
        >
          <img src="/assets/images/logo-gp-kana-raz.svg" />
        </h2>
      </router-link>
    </div>

    <div class="transition-container">
      <div class="transition-item">
        <div>
          <!--<transition name="slide-in">
            <router-view :key="$route.meta.version"/>
          </transition>-->
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab {
  align-items: flex-start !important;

  @include is-mobile {
    height: 3rem;
    gap: .75rem;
  }

  @include is-not-mobile {
    height: 4.5rem;
    gap: 2.5rem;
  }

  h2 {
    padding-bottom: 0;
    transition: padding-bottom .06s ease, opacity .06s linear;
    opacity: .7;

    @include is-mobile {
      height: 2rem;
      width: 10.25rem;
    }

    @include is-not-mobile {
      height: 3rem;
      width: 17rem;
    }

    &.current {
      opacity: 1;
      @include is-mobile {
        padding-bottom: 1rem;
      }

      @include is-not-mobile {
        padding-bottom: 1.5rem;
      }
    }
  }

  h2.gp {
    background-color: #B20C1A;

    img {
      @include is-mobile {
        width: 8rem;
      }
    }
  }

  h2.raz {
    background-color: #FFF;

    img {
      @include is-mobile {
        width: 9.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/staff/staff.vue